import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {debounceTime, Subject, Subscription} from "rxjs";
import {USER_PROFILE_DASHBOARD_ROUTE} from 'src/app/app-routing.module';
import {environment} from "@environment";
import {AbstractComponent, CurrentItemType} from "@components";
import {
  ActionResult,
  EventItem,
  EventItemType,
  FetchEventByIdRequest, League,
  Lookups,
} from "@model";
import {
  ActionService,
  AuthenticationService,
  EventRaceService,
  EventService, LeagueService
} from "@services";

@Component({
  selector: 'app-league-details',
  templateUrl: './league-details.component.html',
  styleUrls: ['./league-details.component.scss']
})
export class LeagueDetailsComponent extends AbstractComponent implements OnInit {
  @Input({required: true}) league: League | undefined;
  @Input({required: true}) countries: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];

  private addToFavoritesButtonSubject: Subject<EventItem | undefined> = new Subject<EventItem | undefined>();

  constructor(
    private leagueService: LeagueService,
    private eventService: EventService,
    public translocoService: TranslocoService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private eventRaceService: EventRaceService,
    private actionService: ActionService) {
    super();
  }

  ngOnInit(): void {
    this.leagueService.setCurrentLeague(this.league);
    this.subscriptions.push(this.subscribeToAddToFavoritesButton());
  }


  subscribeToAddToFavoritesButton(): Subscription {
    return this.addToFavoritesButtonSubject.pipe(debounceTime(environment.debounceActionInterval)).subscribe((eventItem: EventItem | undefined) => {
        if (this.authenticationService.isAuthenticated()) {
          this.addToFavoritesAction(eventItem);
        } else {
          this.actionService.addAction(() => this.addToFavoritesAction(eventItem));
          this.actionService.addAction(() => this.router.navigate([USER_PROFILE_DASHBOARD_ROUTE], {queryParams: {typeOfRace: EventItemType.MY_FAVORITE}}));
        }
      }
    )
  }

  addToFavoritesAction(eventItem: EventItem | undefined): void {
    if (eventItem?.id) {
      this.eventService.findEventById(new FetchEventByIdRequest(eventItem?.id), true).subscribe((value: EventItem | null) => {
        if (value) {
          if (value.id && value.favorite) {
            this.eventRaceService.removeEventFromFavorites(value.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                this.eventRaceService.fetchUserFavoritesEventRaces();
                eventItem.favorite = false;
              }
            });
          } else if (value?.id && !value.favorite) {
            this.eventRaceService.addEventToFavorites(value.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                this.eventRaceService.fetchUserFavoritesEventRaces();
                eventItem.favorite = true;
              }
            });
          }
        }
      });
    }
  }

  protected readonly CurrentItemType = CurrentItemType;
}
